import React from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';
import { Maximize2 } from 'lucide-react';
import { useHistory } from 'react-router-dom';

export const ContactJobApplicationRenderer = ({ data, value }) => {
  const history = useHistory();
  const { colors } = useTheme();
  if (data?.options?.showLoader) {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={160}
        viewBox="0 0 400 160"
        backgroundColor={colors.neutral[50]}
        foregroundColor={colors.neutral[20]}
      >
        <rect x="20" y="16" rx="3" ry="3" width="80" height="8" />
      </ContentLoader>
    );
  }

  return (
    <Flex
      px="8px"
      alignItems="center"
      sx={{
        height: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
        cursor: 'pointer',
        '&:hover #maximize-icon': { opacity: 1 },
      }}
      onClick={() => {
        history.push(data.options.jobApplicationsUrl);
      }}
    >
      <Text
        fontSize="14px"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {value}
      </Text>

      <Box
        id="maximize-icon"
        as={Maximize2}
        sx={{ width: '16px', height: '16px', cursor: 'pointer', opacity: 0, transition: 'opacity 0.3s ease' }}
      />
    </Flex>
  );
};

ContactJobApplicationRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array, PropTypes.bool, PropTypes.object]),
  data: PropTypes.object,
};

ContactJobApplicationRenderer.defaultProps = {
  value: '',
  data: {},
};
